(function () {
  'use strict';

  function formatPrice(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function buildCard(product) {
    var variant =
      product.variants.find(function (v) {
        return v.available;
      }) || product.variants[0];
    if (!variant) return null;

    var image =
      (product.featured_image && (product.featured_image.url || product.featured_image)) ||
      (product.images && product.images[0]) ||
      '';

    var card = document.createElement('div');
    card.className = 'drogueria-cart-crosssell__card';
    card.innerHTML =
      '<a href="' + product.url + '" class="drogueria-cart-crosssell__media">' +
      (image ? '<img src="' + image + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
      '</a>' +
      '<a href="' + product.url + '" class="drogueria-cart-crosssell__title">' + product.title + '</a>' +
      '<span class="drogueria-cart-crosssell__price">' + formatPrice(variant.price) + '</span>' +
      '<product-form data-section-id="cart-crosssell">' +
      '<form method="post" action="/cart/add" accept-charset="UTF-8" class="form" novalidate="novalidate" data-type="add-to-cart-form">' +
      '<input type="hidden" name="id" value="' + variant.id + '" class="product-variant-id">' +
      '<button type="submit" name="add" class="drogueria-cart-crosssell__add" aria-label="Añadir ' +
      product.title.replace(/"/g, '&quot;') +
      '">' +
      '<span>+</span>' +
      '<div class="loading__spinner hidden">' +
      '<svg class="spinner" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<circle opacity="0.3" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3"></circle>' +
      '<path d="M22 12c0-5.523-4.477-10-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>' +
      '</svg>' +
      '</div>' +
      '</button>' +
      '</form>' +
      '</product-form>';
    return card;
  }

  function render(products) {
    var containers = document.querySelectorAll('[data-drogueria-cart-crosssell]');
    containers.forEach(function (container) {
      var list = container.querySelector('[data-drogueria-cart-crosssell-list]');
      if (!list) return;
      list.innerHTML = '';
      if (!products.length) {
        container.hidden = true;
        return;
      }
      products.forEach(function (product) {
        var card = buildCard(product);
        if (card) list.appendChild(card);
      });
      container.hidden = false;
    });
  }

  function hideAll() {
    document.querySelectorAll('[data-drogueria-cart-crosssell]').forEach(function (container) {
      container.hidden = true;
    });
  }

  function refresh() {
    if (!document.querySelector('[data-drogueria-cart-crosssell]')) return;

    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          hideAll();
          return;
        }
        var cartProductIds = cart.items.map(function (item) {
          return item.product_id;
        });
        var seedProductId = cart.items[cart.items.length - 1].product_id;

        fetch('/recommendations/products.json?product_id=' + seedProductId + '&limit=8&intent=related')
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            var products = (data.products || [])
              .filter(function (p) {
                return cartProductIds.indexOf(p.id) === -1 && p.available;
              })
              .slice(0, 3);
            render(products);
          })
          .catch(hideAll);
      })
      .catch(hideAll);
  }

  if (window.subscribe && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
      window.setTimeout(refresh, 50);
    });
  }

  document.addEventListener('click', function (e) {
    var cartIcon = e.target.closest('#cart-icon-bubble, a[href="/cart"]');
    if (cartIcon) window.setTimeout(refresh, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
